import { SceneTypeEnum } from '@/enums/scene-type';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { supplyNeedConfig } from '@/api/userPersonalInfo';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { OpenVerifyPageMode, VerifySceneEnum } from '@/shared/verify-credit-controller/types';

const BaseStore = namespace('base');
const PreApplyChooseStore = namespace('preApplyChoose');

@Component
export class UserInfoCompleteMixins extends Vue {
  @BaseStore.State isLogoutUser!: boolean;

  /** 是否显示职业选择字段 */
  protected professionPickerPop = false;

  /** 当前需要补充字段的渠道 */
  protected needSupplyCommodityIds:string[] = [];

  @PreApplyChooseStore.Action $updateState!: (data: Dictionary) => void;

  // 判断当前用户是否需要补充信息
  public checkSupplyNeed(commodityIds: string[])
  :Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      // 获取补充字段（区分场景）
      const fields = await supplyNeedConfig(commodityIds, SceneTypeEnum.PREAPPLY);

      this.needSupplyCommodityIds = commodityIds;
      const supplyValidFields = fields.filter((name) => name !== 'id');

      if (supplyValidFields && supplyValidFields.length) {
        try {
          // 只需要补充职业字段
          if (supplyValidFields.length === 1
             && supplyValidFields.includes('profession')
          ) {
            this.professionPickerPop = true;
            return;
          }

          // 其他情况用补充资料组件
          jumpToVerifyCredit(VerifySceneEnum.CREDIT_SUPPLY_PERSONAL, {
            commodityIds,
            useReplace: true,
            openMode: OpenVerifyPageMode.POPUP_SHOW,
            successCb: () => {
              resolve(true);
            },
            failCb: () => {
              reject();
            },
          });
        } catch (err) {
          reject();
        }
      } else {
        resolve(true);
      }
    });
  }
}
